import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { downloadCSVData, downloadCanvasWithTitle } from "../utils";
import { Icon } from "semantic-ui-react";
import "./ChannelAnalysis.scss";
import ChannelAnalysisChart from "./ChannelAnalysisChart";
import html2canvas from "html2canvas";
import ChannelAnalysisBarChart from "./ChannelAnalysisBarChart";
import NoData from "../NoData/NoData";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import DownloadChart from "../DownloadChart";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import * as d3 from "d3";

class ChannelAnalysis extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};

        this.chartE1 = React.createRef();
    }

    formatSentimentData(data) {
        let res = [];
        for (let platform in data) {
            let platformName = this.props.allPlatforms.find((plt) => plt.id === platform);
            let fullName = platformName ? platformName.name : "";
            platformName = platformName ? platformName.short_name : "";

            res.push({
                name: platformName,
                fullName: fullName,
                data: data[platform].sentiments,
                total: data[platform].total,
                id: platform,
            });
        }
        return res;
    }

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");
        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleCircularProgessContextClick(chart);
            });
        !this.props.drilldown_charts &&
            contextMenu
                .append("li")
                .text("View Insights")
                .on("click", () => {
                    // console.log('drilldown')
                    this.handleDrilldownClick(chart);
                    // this.props.showChartsDrilldown(true, "channelAnalysis");
                });
        contextMenu.style("display", "block");
    };

    createNewFilter(d) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};

        newFilter.platforms = [d.platformId];
        newFilter.extras = [];

        return newFilter;
    }

    handleCircularProgessContextClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleContextMenuClick(newFilter);
    }

    handleDrilldownClick = (d) => {
        let newFilter = this.createNewFilter(d);

        this.props.handleDrilldownClick(newFilter);
    };

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let csvFmt = [["Platform", "Mentions"]].concat(
            this.formatSentimentData(this.props.data.data).map((platform) => {
                let gendername = platform.fullName.split("");
                let initLetter = gendername[0].toUpperCase();
                let actualName = gendername.slice(1, gendername.length);

                actualName.unshift(initLetter);
                actualName = actualName.join("");
                return [actualName, platform.total];
            }),
        );
        downloadCSVData(csvFmt, this.props.widget.name);
    };

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        html2canvas(this.chartE1.current, { backgroundColor: options.background ? "#fff" : null, allowTaint: true, useCORS: true }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    renderFirstDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    }

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName name={this.props.widget.name} info="Allows you to see a breakdown of platforms based on conversation volumes." />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!nodata && (
                            <div className="chart-type">
                                <span onClick={() => this.props.changeGraphType("pie")} className={this.props.graph_type === "pie" ? "active-chart" : ""}>
                                    <Icon name="pie chart" />
                                </span>
                                <span onClick={() => this.props.changeGraphType("bar")} className={this.props.graph_type === "bar" ? "active-chart" : ""}>
                                    <Icon name="bar chart" />
                                </span>
                            </div>
                        )}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && this.renderFirstDownloadButton(nodata)}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }

                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && <CustomCheckBox checked={this.props.showLabel} onClick={this.props.changeShowLabel} label="Show Labels" />}
                        {!nodata && <CustomCheckBox checked={this.props.hideLegendPie} onClick={() => this.props.changeHideLegendPie()} label="Show Legends" />}
                        {!nodata && this.props.graph_type !== "pie" && (
                            <CustomCheckBox checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} label="Show Grid Lines" />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic && !this.props.isStandardDashboard && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}

                {!nodata ? (
                    <div className="dashboard-chart skiptranslate" ref={this.chartE1}>
                        {this.props.graph_type === "pie" ? (
                            <ChannelAnalysisChart
                                data={this.props.data.data}
                                allPlatforms={this.props.allPlatforms}
                                // resizedCount={this.props.resizedCount}
                                addContextMenuListener={this.addContextMenuListener}
                                showLabel={this.props.showLabel}
                                showLegendBar={this.props.hideLegendPie}
                                showLegend={this.props.hideLegendPie}
                                widgetContainerRef={this.props.widgetContainerRef}
                            />
                        ) : (
                            <ChannelAnalysisBarChart
                                data={this.props.data.data}
                                addContextMenuListener={this.addContextMenuListener}
                                allPlatforms={this.props.allPlatforms}
                                // resizedCount={this.props.resizedCount}
                                showLegendBar={this.props.hideLegendPie}
                                showGridLines={this.props.showGridLines}
                                showLabel={this.props.showLabel}
                                showLegend={this.props.showLegend}
                                widgetContainerRef={this.props.widgetContainerRef}
                            />
                        )}
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        //allPlatforms: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.platforms : [],
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChannelAnalysis);
